var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 160 160",
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#feb111",
    d: "M114 80c8.938 0 17.052 3.577 23 9.368V84c0-22.542-16.198-41.64-38.38-47.859l-1.073 15.001a2 2 0 1 1-3.991-.285L95.027 30.3a4.133 4.133 0 0 0-1.077-3.104A3.671 3.671 0 0 0 91.245 26h-16.49a3.67 3.67 0 0 0-2.706 1.197 4.128 4.128 0 0 0-1.077 3.104l1.47 20.557a2 2 0 1 1-3.991.285L67.38 36.141C45.198 42.36 29 61.458 29 84v17h54.269C88.08 88.722 100.037 80 114 80zM30 119h51.557a33.047 33.047 0 0 1-.557-6c0-2.759.345-5.437.986-8H30c-3.86 0-7 3.141-7 7s3.14 7 7 7z",
    opacity: 1,
    "data-original": "#ffb845",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M147 112c0-.464-.038-.918-.094-1.367A32.791 32.791 0 0 0 141 94.062V84c0-24.639-17.822-45.461-42.09-51.917l.107-1.497a8.146 8.146 0 0 0-2.14-6.115C95.394 22.877 93.394 22 91.245 22h-16.49c-2.148 0-4.149.878-5.633 2.471a8.146 8.146 0 0 0-2.14 6.115l.107 1.497C42.822 38.539 25 59.361 25 84v18.214c-3.556 1.824-6 5.521-6 9.786 0 6.065 4.935 11 11 11h52.553c4.246 13.322 16.736 23 31.447 23 18.196 0 33-14.804 33-33 0-.223-.012-.444-.017-.666.003-.112.017-.221.017-.334zm-33 30c-15.99 0-29-13.01-29-29s13.01-29 29-29 29 13.01 29 29-13.01 29-29 29zm-85-41V84c0-22.542 16.198-41.64 38.38-47.859l1.073 15.002a2.005 2.005 0 0 0 2.138 1.853 2.001 2.001 0 0 0 1.853-2.138l-1.47-20.557a4.126 4.126 0 0 1 1.077-3.104A3.665 3.665 0 0 1 74.755 26h16.49a3.67 3.67 0 0 1 2.705 1.197 4.129 4.129 0 0 1 1.077 3.104l-1.471 20.557a2.001 2.001 0 0 0 3.991.285l1.073-15.001C120.802 42.36 137 61.458 137 84v5.368C131.052 83.577 122.938 80 114 80c-13.963 0-25.92 8.722-30.731 21H30zm1 4h51.986a32.926 32.926 0 0 0-.986 8c0 2.05.197 4.053.557 6H30c-3.86 0-7-3.141-7-7s3.14-7 7-7z",
    opacity: 1,
    "data-original": "#000547",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f5808",
    d: "M114 84c-15.99 0-29 13.01-29 29s13.01 29 29 29 29-13.01 29-29-13.01-29-29-29zm-.586 44.414c-.391.391-.902.586-1.414.586s-1.023-.195-1.414-.586l-14.5-14.5a2 2 0 1 1 2.828-2.828L112 124.172l20.086-20.086a2 2 0 1 1 2.828 2.828z",
    opacity: 1,
    "data-original": "#4cd35c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M134.914 106.914a2 2 0 1 0-2.828-2.828L112 124.172l-13.086-13.086a2 2 0 1 0-2.828 2.828l14.5 14.5c.391.391.902.586 1.414.586s1.023-.195 1.414-.586z",
    opacity: 1,
    "data-original": "#000547",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/operator.e30698a2ecebb82b0448cb211ab45308.svg";
export { ForwardRef as ReactComponent };